














import PopupCircleEpisode from '@/views/templates/kuntama/PopupCircleEpisode.vue'

export default
  components: {
    PopupCircleEpisode
  }

  data: () ->
    message: [
      'くんたま王子大阪店に到着したよ！'
      'こげ茶色にきれいに色づいた'
      'つややかなたまごがあるね。'
      '一体どんな燻製たまごなんだろうね。'
      ''
      'クイズに答えてもらったポイントは'
      'お店で使えるからぜひ集めてみてね！'
      ''
      'あ、あの人が桑野さんかな？'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    addPoint: (point) ->
      @$emit('addPoint', point)
  }
